<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="添加银行卡"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name">银行卡账号：</div>
          <Input
            class="height45"
            v-model.trim="form.bankCardNumber"
            maxlength="19"
            placeholder="请输入银行卡账号"
            @on-blur="bankNumberInput"
            @on-keyup="bankNumberChange"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">确认银行卡号：</div>
          <Input
            class="height45"
            disabled
            v-model="form.confirmBankCardNumber"
            maxlength="19"
            placeholder="请输入确认银行卡号"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">银行名称：</div>
          <div>
            <Input
              class="height45"
              disabled
              v-model="form.bankName"
              maxlength="19"
              placeholder="请输入银行卡账号"
              style="width: 200px"
              clearable
            />
          </div>
        </div>
        <div class="col">
          <div class="name">开户地区：</div>
          <div class="row">
            <Select
              class="height45"
              v-model="form.province"
              filterable
              transfer
              style="margin-right: 10px; width: 120px"
              @on-change="changeProvince"
            >
              <Option
                v-for="(item, index) in areas"
                :key="'p' + index"
                :value="item.value"
                >{{ item.label }}</Option
              >
            </Select>
            <Select
              class="height45"
              v-if="form.province != null && form.province != ''"
              v-model="form.city"
              style="margin-right: 10px; width: 120px"
              filterable
              transfer
              @on-change="changeCity"
            >
              <Option
                v-for="item in cityList"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</Option
              >
            </Select>
            <Select
              class="height45"
              transfer
              v-if="
                form.province != null &&
                form.province != '' &&
                form.city != null &&
                form.city != ''
              "
              v-model="form.region"
              filterable
              style="width: 120px"
            >
              <Option
                v-for="item in areaList"
                :key="item.value"
                :value="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </div>
        </div>
        <div class="col">
          <div class="name">开户支行：</div>
          <Input
            class="height45"
            v-model="form.bankBranch"
            placeholder="请输入支行信息"
            style="width: 200px"
            clearable
          />
        </div>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { createBankCard, getBankName } from "api/customer.js";
import { mapState, mapMutations, mapActions } from "vuex";
import loading from "components/loading.vue";
import { debounce } from "utils/index";
export default {
  name: "addBackModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        bankName: "请先输入银行卡账号",
        bankCardNumber: "",
        confirmBankCardNumber: "",
        city: "",
        province: "",
        region: "",
        bankBranch: "",
      },
      cityList: [], // 城市数据
      areaList: [], // 地区数据
      loading: false,
    };
  },
  computed: {
    ...mapState(["areas"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  async mounted() {
    if (this.areas.length === 0) {
      await this.ACT_REGION_LIST();
    }
  },
  methods: {
    ...mapMutations(["MUT_TOKEN_INFO"]),
    ...mapActions(["ACT_REGION_LIST"]),
    // 银行卡号读取银行名称
    bankNumberInput() {
      this.form.bankCardNumber = this.form.bankCardNumber.replace(
        /[^\d.]/g,
        ""
      );
      this.req_getBankName();
    },
    // 银行卡号输入事件
    bankNumberChange() {
      this.form.bankCardNumber = this.form.bankCardNumber.replace(
        /[^\d.]/g,
        ""
      );
    },
    // 获取银行卡名称接口
    req_getBankName: debounce(function () {
      if (!this.form.bankCardNumber) {
        return false;
      }
      this.loading = true;
      getBankName(this.form.bankCardNumber)
        .then((res) => {
          this.loading = false;
          const { code, data, result } = res;
          if (code === 200 && result) {
            this.form.bankName = data;
            this.form.confirmBankCardNumber = this.form.bankCardNumber;
          } else {
            this.form.bankName = "";
          }
        })
        .catch(() => {
          this.loading = false;
        });
    }, 500),
    // 取消添加
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    // 确认提交
    async onConfirm() {
      if (!this.$store.state.user.name) {
        this.$Message.warning('请先进行实名认证！');
        return;
      }
      if (!this.form.bankCardNumber) {
        this.$Message.warning("请输入银行卡账号！");
        return;
      }
      if (!this.form.confirmBankCardNumber) {
        this.$Message.warning("请输入再次输入银行卡账号！");
        return;
      }
      if (this.form.bankCardNumber !== this.form.confirmBankCardNumber) {
        this.$Message.warning("两次银行卡账号输入不一致！");
        return;
      }
      if (this.form.bankName === "" || this.form.bankName === "银行卡不存在") {
        this.$Message.warning("银行卡不存在！");
        return;
      }
      if (!this.form.province || !this.form.city || !this.form.region) {
        this.$Message.warning("请选择开户地区！");
        return;
      }
      if (!this.form.bankBranch) {
        this.$Message.warning("请输入开户支行！");
        return;
      }
      const data = {
        yhk: this.form.bankCardNumber,
        yhk2: this.form.confirmBankCardNumber,
        yh: this.form.bankName,
        sheng: this.form.province,
        shi: this.form.city,
        qu: this.form.region,
        zh: this.form.bankBranch,
      };
      this.loading = true;
      try {
        const res = await createBankCard(data);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("设置成功！");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 省改变
    changeProvince() {
      if (!this.form.province) {
        return false;
      }
      let selectArray = this.areas.filter(
        (o) => o.value === this.form.province
      );
      this.cityList = selectArray[0].children;
      this.form.city = "";
      this.form.street = "";
    },
    // 城市改变
    changeCity() {
      if (this.form.city) {
        let selectArray = this.cityList.filter(
          (o) => o.value === this.form.city
        );
        this.areaList = selectArray[0].children;
        this.form.street = "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
.row {
  display: flex;
  align-items: center;
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input[disabled] {
    color: #333;
  }
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
